import Cookies from 'js-cookie';
import { AuthnTransaction, OktaAuth, UserClaims } from '@okta/okta-auth-js';
import { ILoginService } from './interfaces.js';
import type { AccessToken } from '@okta/okta-auth-js';
import type { EnvironmentConfig } from '../../environments/interfaces.js';

export class LoginService implements ILoginService {
  private authClient: OktaAuth;
  private userInfoEndpoint: string | undefined;
  private cookieDomainEndpoint: string | undefined;

  constructor(config: EnvironmentConfig['endpoints']['myCignaLogin']) {
    this.authClient = new OktaAuth({
      redirectUri: config.redirectUri,
      clientId: config.clientId,
      issuer: config.issuer,
      pkce: true,
      responseType: 'code',
    });
    this.userInfoEndpoint = config.userInfo;
    this.cookieDomainEndpoint = config.cookieDomain;
  }

  // not used currently
  async isAuthenticated(): Promise<boolean> {
    return await this.authClient.session.exists();
  }

  async setCookie(): Promise<void> {
    Cookies.set('OEP_li', 'true', { expires: 365, domain: this.cookieDomainEndpoint });
  }

  async login(username: string, password: string): Promise<AuthnTransaction> {
    const transaction = await this.authClient.signInWithCredentials({ username, password });
    if (transaction.status === 'MFA_REQUIRED') {
      return transaction;
    }
    const response = await this.authClient.token.getWithoutPrompt({
      scopes: ['openid'],
      sessionToken: transaction.sessionToken,
    });
    if (response.tokens.accessToken) {
      this.authClient.tokenManager.add('accessToken', response.tokens.accessToken);
      this.setCookie();
    }
    return transaction;
  }

  // not used currently
  async getUser(authenticated: Promise<boolean>): Promise<UserClaims | undefined> {
    const auth = await authenticated;
    if (!auth) {
      return;
    }
    const tokenResponse = (await this.authClient.tokenManager.get('accessToken')) as AccessToken;
    const response = await fetch(this.userInfoEndpoint as RequestInfo | URL, {
      headers: {
        Authorization: `Bearer ${tokenResponse?.accessToken}`,
      },
    });
    return await response.json();
  }
}
